import PhoneIphoneIcon from '@mui/icons-material/PhoneIphone';
import { Button, Tooltip } from '@mui/material';
import { useState } from 'react';
import { useRecordContext } from 'react-admin';
import { artboardsFor, focusedModel } from '../lib/artboards';
import { AppArt } from '../types';
import MockupDialog from './MockupDialog';

/**
 * Abre o mockup ao vivo do modelo em foco — o escolhido pelo cliente, ou o mais
 * recente.
 *
 * Fica no cabeçalho porque o mockup serve nas duas pontas do fluxo: no rascunho
 * ainda não há arte nenhuma, e mesmo assim vale abrir para acertar as cores e
 * decidir se a logo precisa de um fundo ANTES de mandar gerar; depois, é como
 * se revê a arte aprovada sem caçar o card certo.
 */
const ViewInAppButton = ({ editable }: { editable?: boolean }) => {
  const record = useRecordContext<AppArt>();
  const [open, setOpen] = useState(false);

  if (!record) { return null; }

  const files = record.files || [];
  const model = focusedModel(files);
  const artboards = artboardsFor(files, model);

  return (
    <>
      <Tooltip title="Monta as telas do app com a arte atrás e o chrome ajustável">
        <Button
          size="small"
          variant="outlined"
          startIcon={<PhoneIphoneIcon />}
          onClick={() => setOpen(true)}
        >
          Ver no app
        </Button>
      </Tooltip>

      <MockupDialog
        open={open}
        onClose={() => setOpen(false)}
        record={record}
        title={model ? (model.caption || model.fileName || 'Ver no app') : 'Ver no app'}
        model={model}
        welcomeArt={artboards.welcome}
        headerArt={artboards.header}
        editable={editable}
      />
    </>
  );
};

export default ViewInAppButton;
